 const API_BASE_URL = 'https://live-vastu-backend.onrender.com/api';
    const SITE_KEY = '411998a29f2746b7737bccff0ee517bf'
    let plans;
    let customerEmail;
    let selected_plan_id;

    let session_id = sessionStorage.getItem('vastu_session_id') ? sessionStorage.getItem('vastu_session_id') : 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    sessionStorage.setItem('vastu_session_id', session_id);

    function renderPlans() {
    const plansContainer = document.querySelector('.pricing-grid');

    let plansHtml = '';
    
plansHtml += plans.map(plan => 
   { 

   return `<div class="plan-card ${plan.type} ${plan.recommend ? 'recommended' : ''}">
   ${plan.recommend ? '<div class="badge">Recommended</div>' : ''}
    <div class="plan-header">
                    <h3>${plan.name}</h3>
                    <p>Smart analysis powered by traditional wisdom.</p>
                    <div class="discount">${plan.discount}% discount</div>
                    <div class="price"><span style="text-decoration: line-through;font-size: 1.2rem;
    font-weight: 600;
    color: #666464;">₹${plan.cut_price}</span><br> ₹${plan.price}</div>
                    <a class="btn-scan black" onclick="selectPlan('${plan._id}')">Scan Now</a>
                </div>
        <ul class="plan-features">
                   ${plan.features.map(feature => `<li>${feature}</li>`).join("")}
                </ul>
  </div>`}).join('');

plansHtml += `</div>`;
plansContainer.innerHTML = plansHtml;

}

  async function initPlan() {
    try {
        // Load plans from backend
        const response = await fetch(`${API_BASE_URL}/plans`,{
        headers:{"x-site-key": SITE_KEY}
      });
        const result = await response.json();
        
        if (result.success) {
            plans = result.data;
            renderPlans();
        } else {
            document.querySelector('.pricing-grid').innerHTML = `
                <div style="background: #ffe7e7; padding: 20px; border-radius: 5px;">
                    <p>Error loading plans. Please refresh the page.</p>
                </div>
            `;
        }
    } catch (error) {
        console.error('Error loading plans:', error);
        document.querySelector('.pricing-grid').innerHTML = `
            <div style="background: #ffe7e7; padding: 20px; border-radius: 5px;">
                <p>Error loading plans. Please try again later.</p>
            </div>
        `;
    }
}


function checkPlan(){
  const selectedPlan = plans.find(plan => plan._id === selected_plan_id);
    
    if (selectedPlan) {
       
        // Store selected plan in sessionStorage
        sessionStorage.setItem('selected_plan', selectedPlan.type);
        redirectToShopifyCheckout(selectedPlan);
    }
}


async function selectPlan(planId) {
    
    const selectedPlan = plans.find(plan => plan._id === planId);
    if(selectedPlan.type == "bronze") {
           return window.location.href = '/pages/vastu-quiz'
        }
    
          selected_plan_id = planId
          if (window.IS_LOGGED_IN) {
               customerEmail = window.CUSTOMER_EMAIL
               checkPlan() 

         } else {
          
         showMobileVerification();  
          }

    
}

function redirectToShopifyCheckout(plan) {
   
    const variantIds = {
        'silver': '51401792553272', 
        'gold': '51401779773752', 
        'platinum': '51401807462712'
    };
    
    const variantId = variantIds[plan.type];
   const sessionId = sessionStorage.getItem("vastu_session_id")
   const PlanType = sessionStorage.getItem("selected_plan")
    
    if (variantId) {
        // Direct checkout link
        window.location.href = `/cart/${variantId}:1?attributes[session_id]=${sessionId}&attributes[plan_type]=${PlanType}&attributes[email]=${customerEmail}`;
    } else {
        alert('Error: Plan not available. Please contact support.');
    }
}

function showMobileVerification() {   
    // Show mobile verification
    document.getElementById('plans-container').innerHTML = `<div id="emailVerification">
  <div class="verification-card">
    <p>Please verify your email before take any plan.</p>
    
    <form id="emailForm">
      <div class="form-group">
        <label for="emailId">Email:</label>
        <input type="email" id="emailId" placeholder="Enter your email" required>
      </div>
      
      <button type="submit" class="btn-primary" onclick="submitEmailForm(event)">Send OTP</button>
    </form>
    
    <div id="otpSection" style="display: none;">
      <div class="form-group">
        <label for="otpCode">Enter OTP:</label>
        <input type="text" id="otpCode" placeholder="Enter 6-digit OTP" maxlength="6" required>
      </div>
      
      <button onclick="verifyOTP(event)" class="btn-success">Verify OTP</button>
      <button id="resendBtn" class="btn-secondary" onclick="submitEmailForm(event)">Resend OTP</button>
    </div>
  </div>
</div>`;
    // document.querySelector(".plan-section").style.display = 'none'

}


async function submitEmailForm(e) {

    
    e.preventDefault();
    const email = document.getElementById('emailId').value.trim();

    if (!email || !email.includes("@")) {
        alert("Please enter a valid email address");
        return;
    }
    
    customerEmail = email;
    
    try {
        const res = await fetch(`${API_BASE_URL}/user-submissions/send-email-otp`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "x-site-key": SITE_KEY },
            body: JSON.stringify({ email })
        });

        const data = await res.json();

        if (!data.success) {
            alert(data.message || "Failed to send OTP");
            return;
        }

        alert(data.message);
        document.getElementById("otpSection").style.display = "block";

    } catch (err) {
        console.error(err);
        alert("Something went wrong while sending OTP");
    } 
    
}








async function verifyOTP(e) {
     e.preventDefault();
    const otp = document.getElementById('otpCode').value.trim();
     const email = document.getElementById('emailId').value.trim();

      if (!otp || otp.length !== 6) {
        alert("Please enter a valid 6-digit OTP");
        return;
    }
    
    // Basic validation
    if (!email || !email.includes("@")) {
        alert('Please enter a valid email');
        return;
    }

     customerEmail = email;
  
       
        try {
        
         const res = await fetch(`${API_BASE_URL}/user-submissions/verify-email-otp`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "x-site-key": SITE_KEY },
            body: JSON.stringify({
                email: customerEmail,
                otp: otp
            })
        });

        const data = await res.json();

        if (!data.success) {
            alert(data.message || "Invalid OTP");
            return;
        }

        alert(data.message);
        if(data.success)
        checkPlan()

    } catch (error) {
        console.error(error);
        alert("Something went wrong while verifying otp.");
    }
    
}

document.addEventListener('DOMContentLoaded',function(){
    initPlan()
})